import React, { createContext, useContext } from 'react';
import { useFeatureFlags } from './hook';
import { STATUS } from './constants';
import { State } from './types';

const initialState = {
  state: {
    error: null,
    status: STATUS.IDLE,
    featureFlags: undefined,
    isInitializedFromBrowserStorage: false,
  },
  handleSetFeatureFlags: () => {},
  resetFeatureFlags: () => {},
};

type ProviderValue = {
  state: State;
  handleSetFeatureFlags: () => void;
  resetFeatureFlags: () => void;
};

const FeatureFlagsContext = createContext<ProviderValue>(initialState);

export const useFeatureFlagsCtx = () => useContext(FeatureFlagsContext);
export const FeatureFlagsProvider = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const { state, handleSetFeatureFlags, resetFeatureFlags } = useFeatureFlags();
  return (
    <FeatureFlagsContext.Provider
      value={{
        state,
        handleSetFeatureFlags,
        resetFeatureFlags,
      }}
    >
      {children}
    </FeatureFlagsContext.Provider>
  );
};
